<template>
  <aside id="sidebar" :style="style">
    <aside v-if="user" class="aside-open h-100">
      <div class="sidebar-header mb-3">
        <img :title="user.email" :src="logoPath" class="sidebar-brand" />
      </div>
      <div class="sidebar-body d-flex flex-column">
        <nav class="sidebar-nav">
          <ul class="nav flex-column">
            <template v-for="(item, index) of sidebarTopItems">
              <li class="nav-item" v-if="user.isOneOf(item.roles)" :key="index">
                <router-link
                  v-if="item.name"
                  tag="div"
                  :to="{ name: item.name }"
                  class="nav-link d-flex py-3 clickable"
                  :disabled="item.disabled"
                  ><v-icon
                    :class="
                      routeActive(item.name) ? 'text-primary' : 'text-abbey'
                    "
                    >{{ item.icon }}</v-icon
                  ></router-link
                >
                <div
                  v-else
                  @click="item.onClick()"
                  class="nav-link d-flex py-3 clickable"
                  :disabled="item.disabled"
                >
                  <v-icon>{{ item.icon }}</v-icon>
                </div>
              </li>
            </template>
          </ul>
        </nav>
        <nav class="sidebar-nav mt-auto d-flex">
          <ul class="nav">
            <template v-for="(item, index) of bottomItems">
              <li v-if="user.isOneOf(item.roles)" class="nav-item" :key="index">
                <router-link
                  v-if="item.name"
                  tag="div"
                  :to="{ name: item.name }"
                  class="nav-link d-flex py-3 clickable"
                  :disabled="item.disabled"
                >
                  <v-icon
                    :class="
                      routeActive(item.name) ? 'text-primary' : 'text-abbey'
                    "
                    >{{ item.icon }}</v-icon
                  >
                </router-link>
                <div
                  v-else
                  @click="item.onClick()"
                  class="nav-link d-flex py-3 clickable"
                  :disabled="item.disabled"
                >
                  <v-icon class="text-abbey">{{ item.icon }}</v-icon>
                </div>
              </li>
            </template>
          </ul>
        </nav>
      </div>
      <div class="loading d-flex p-4 w-100" v-if="sidebarLoading">
        <p class="m-auto">
          <fa-icon icon="circle-notch" class="text-primary mr-2" spin></fa-icon>
          Loading...
        </p>
      </div>
    </aside>
  </aside>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { currentUserStore } from "@/store/typed";
import { User } from "../models";
import store from "../store";
import { UserRoles } from "@/models/User";

export interface SidebarItem {
  name?: string;
  icon: string;
  onClick?: any;
  disabled?: boolean;
  roles?: string[];
}

@Component
export default class TheSidebar extends Vue {
  topItems: SidebarItem[] = [
    {
      name: "scouting",
      icon: "menu-map",
      roles: ["anyone"],
    },
    {
      name: "companies_branch",
      icon: "menu-clients",
      roles: [
        UserRoles.ANALYST,
        UserRoles.ADMINISTRATOR,
        UserRoles.SUPERADMIN,
        UserRoles.SYSTEM_ADMIN,
      ],
    },
  ];

  bottomItems: SidebarItem[] = [
    {
      name: "settings",
      icon: "menu-settings",
      roles: [
        UserRoles.ADMINISTRATOR,
        UserRoles.SUPERADMIN,
        UserRoles.SYSTEM_ADMIN,
      ],
    },
    {
      onClick: this._logout,
      icon: "menu-logout",
      roles: ["anyone"],
    },
  ];

  get adminRoles() {
    return User.adminRoles.map((o) => o.id);
  }

  get sidebarTopItems() {
    return this.topItems;
  }

  get logoPath() {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require("@/assets/icons/logo.svg").default;
  }

  get user() {
    return currentUserStore.user;
  }

  open = false;

  get sidebarOpen() {
    return this.isTablet && !this.open;
  }

  get style() {
    return { "z-index": 2000 };
  }

  get isSystemAdmin(): boolean {
    if (!this.user) {
      return false;
    }

    return this.user.isSystemAdmin;
  }

  _logout() {
    store.dispatch("logout").then(() => {
      window.location.reload();
    });
  }

  get sidebarLoading() {
    return false;
  }

  routeActive(name: string) {
    return this.$isRouteActive(name);
  }

  get isTablet() {
    return this.$mq === "sm" || this.$mq === "md" || this.$mq === "lg";
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/vue";

.collapsed {
  width: $aside-width-collapsed !important;
  position: absolute;
  top: 0;
}

.aside-open {
  width: $aside-width !important;
  padding-bottom: $sidebar-header-height * 1.5;
}

.test > div {
  flex: 1;

  display: flex;
  justify-content: center;
  flex-direction: column;
}

.slide-fade-enter-active {
  transition: width 0.3s ease;
  > * {
    opacity: 0;
  }
}
.slide-fade-leave-active {
  transition: width 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  > * {
    opacity: 0;
  }
}
.loading {
  position: absolute;
  bottom: 0;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  width: $aside-width-collapsed !important;
}
</style>
